import * as ko from "knockout";
import {IKnockoutComponent, IMessageData} from "../../../index";
import {nsUserWizard} from "./nsUserWizard";
import {ObjectTypeId} from "../../../constants";
import {KOSubscriptionTracker} from "../../../util/KOSubscriptionTracker";
import {IDataset} from "./index";
import {AbstractModel} from "./AbstractModel";
import TWizardSyncfield = nsUserWizard.TWizardSyncfield;

export interface IStepParams<TModel extends AbstractModel = AbstractModel> {
    model: TModel
    dataset: IDataset
}

export abstract class AbstractStep<TModel extends AbstractModel = AbstractModel> {
    protected readonly isReady: KnockoutObservable<boolean> = ko.observable(true)
    protected readonly messageData: KnockoutObservable<IMessageData | null> = ko.observable(null)
    protected readonly kosub: KOSubscriptionTracker = new KOSubscriptionTracker()
    protected readonly model: TModel
    protected dataset: IDataset;

    constructor(params: IStepParams<TModel>) {
        this.model = params.model
        this.dataset = params.dataset
    }

    private getTranslationComponent(key: TWizardSyncfield): IKnockoutComponent {
        return { name: 'component/component/proxy', params: { component: {
            name: 'component/variable/syncfield-name',
            params: {
                key: key,
                objecttypeid: ObjectTypeId.User,

            },
        } } }
    }

    private getDisplayValue(key: TWizardSyncfield): string {
        const observable = this.model.attr[key] ?? this.model.derived[key]
        return observable?.() ?? '—'
    }

    dispose() {
        this.kosub.unsuscribeAll()
    }

}
